import { Grid, Typography } from '@mui/material';
import { styles } from '~/modules/auth/styles.ts';
import { infoMessages } from '~/constants/infoMessages.ts';
import { BaseModal } from '~/components/modals/BaseModal/BaseModal';

export type ResetPasswordModal = {
  isOpened: boolean;
  closeModal: () => void;
};

export const ResetPasswordModal = ({ isOpened, closeModal }: ResetPasswordModal) => {
  return (
    <Grid>
      <BaseModal
        open={isOpened}
        onClose={closeModal}
        containerProps={{ sx: styles.modalContainer }}
      >
        <Grid sx={styles.modalContent}>
          <Typography variant={'h4'} sx={styles.modalContentTitleText}>
            Відновлення пароля
          </Typography>
          <Typography variant={'body1'}>{infoMessages.PASSWORD_RECOVERY_MESSAGE}</Typography>
        </Grid>
      </BaseModal>
    </Grid>
  );
};
